<template>
<span class="d-flex align-items-center gap-4">
	<span
		v-for="key in unitKeys"
		:key="key"
		class="d-inline-flex align-items-center flex-nowrap text-nowrap"
	>
		<unit-icon
			v-if="unitConnectionVector(key).old !== unitConnectionVector(key).new"
			:unitType="key"
			edgeSize="20"
			:color="connectionColor(unitConnectionVector(key).old)"
			
		/>
		<svg
			v-if="unitConnectionVector(key).old !== unitConnectionVector(key).new"
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="currentColor"
			class="mx-1"
			style="min-width: 16px; min-height: 16px; flex-shrink: 0;"
			viewBox="0 0 16 16"
		>
			<path
				fill-rule="evenodd"
				d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
			/>
		</svg>
		<unit-icon
			:unitType="key"
			edgeSize="20"
			:color="connectionColor(unitConnectionVector(key).new)"
		/>
		
		<!-- <span class="ps-1">
			{{ unitNames[key] }}
		</span> -->
	</span>
</span>
</template>



<script>
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { capitalizeFirstLetter } from '@/helpers.js'
import {
	eventSchema,
 } from '@/composables/events.js'
import { Station } from '@/models/station.js'
import { connectionColor, } from '@/helpers.js'


export default {
	components: {
		UnitIcon,
	},
	
	props: {
		[eventSchema.payload.allowed.unitsСonnectionState.key]: {
			// Object schema: { unitKey: { old: Boolean, new: Boolean } }
			type: Object,
			required: true,
		},
	},

	setup() {
		const unitKeys = [
			eventSchema.payload.allowed.unitsСonnectionState.powerUnit.key,
			eventSchema.payload.allowed.unitsСonnectionState.serviceUnit.key,
			eventSchema.payload.allowed.unitsСonnectionState.modemUnit.key,
			eventSchema.payload.allowed.unitsСonnectionState.breaker.key,
			eventSchema.payload.allowed.unitsСonnectionState.electricMeterUnit.key,
		]

		return {
			capitalizeFirstLetter,
			eventSchema,
			Station,
			connectionColor,
			unitKeys,
		}
	},

	methods: {
		unitConnectionVector(unitKey) {
			return this.$props[eventSchema.payload.allowed.unitsСonnectionState.key][unitKey]
		},

		unitConnectionColor(vector) {
			if (vector.old === false && vector.new === true) {
				return true
			} else if (vector.old === true && vector.new === false) {
				return false
			} else {
				return null
			}
		},
	},

	computed: {
		// unitNames() {
		// 	const names = Object.assign({}, Station.unitNames)
		// 	names[eventSchema.payload.allowed.unitsСonnectionState.electricMeterUnit.key] = Station.unitNames[Station.passportKeys.electricMeter.self]
		// 	return names
		// }
	},
}
</script>